import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
  AppstoreOutlined,
  ProjectOutlined,
  ApartmentOutlined,
  SettingOutlined,
  FileTextOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { Collapse } from 'antd';

import Header from '@common/Header';
const { SubMenu } = Menu;
export default function MngAdminLayout({ children }) {
  const { pathname } = useLocation();

  return (
    <Layout>
      <Header />

      <Layout>
        <Layout.Sider className="bg-light shadow-sm">
          <Menu
            mode="inline"
            selectedKeys={[pathname]}
            defaultOpenKeys={['mgnt-project', 'mgnt-estimates', 'mgnt-company', 'mgnt-system']}
            style={{ height: '100%', borderRight: 0 }}
          >
            <SubMenu key="mgnt-project" icon={<AppstoreOutlined />} title="프로젝트 관리">
              <Menu.Item key="/admin/managing/project">
                <Link to="/admin/managing/project">프로젝트 관리</Link>
              </Menu.Item>
              <Menu.Item key="/admin/managing/vendorcodes">
                <Link to="/admin/managing/vendorcodes">벤더코드 관리</Link>
              </Menu.Item>
            </SubMenu>

            {/* <SubMenu key="mgnt-estimates" icon={<FileTextOutlined />} title="산정 관리">
              <Menu.Item key="/admin/estimates/projects">
                <Link to="/admin/estimates/projects">산정 프로젝트 관리</Link>
              </Menu.Item>
            </SubMenu> */}

            <SubMenu key="mgnt-users" icon={<FileTextOutlined />} title="회원 관리">
              <Menu.Item key="/admin/estimates/users">
                <Link to="/admin/managing/users">회원 관리</Link>
              </Menu.Item>
            </SubMenu>

            {/* <SubMenu
        key="mgnt-company"
        icon={<TeamOutlined />}
        title="참여기업 관리"
      >
        <Menu.Item key="/admin/companies">
          <Link to="/admin/companies">참여기업 관리</Link>
        </Menu.Item>
      </SubMenu> */}

            {/* <SubMenu
        key="mgnt-system"
        icon={<SettingOutlined />}
        title="시스템 관리"
      >
        <Menu.Item key="/admin/system">
          <Link to="/admin/system">시스템 관리</Link>
        </Menu.Item>
      </SubMenu> */}
          </Menu>
        </Layout.Sider>
        <Layout.Content className="px-5 py-4">{children}</Layout.Content>
      </Layout>
    </Layout>
  );
}
